<ion-header class="map-header">
    <ion-toolbar>

        <ion-title mode="ios" role="heading" class="transit-detail-header">{{ prompt }}</ion-title>

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismissNoneChosen()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>

</ion-header>

<ion-content>
    <div #map id="map">
        <!-- <page-map-type *ngIf="mapLoaded"></page-map-type> -->
        <div class="map-spinner" *ngIf="!mapLoaded">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ion-content>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        FOOTER
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<!-- <ion-footer class="map-footer" *ngIf="isDevice">
        <ion-button expand="full" color="participant-gradient" (click)="dismiss()"
        [disabled]="disableSelectButton">Confirm Selection</ion-button>
    </ion-footer> -->

<!-- <ion-footer class="map-footer" *ngIf="isDevice">
        <ion-button expand="full" color="participant-gradient" (click)="dismiss()"
        [disabled]="disableSelectButton">Confirm Selection {{ chosenPoint.text }}</ion-button>
    </ion-footer> -->